import { App } from './App';
if (window.history.replaceState) {
  window.history.replaceState(null, ``, window.location.href);
}
App.start();